import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
export var LineChart = function LineChart(_ref) {
  var data = _ref.data,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 90 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 24 : _ref$height;
  var safe = 6;
  var processed = data.map(function (item, index) {
    return {
      x: index,
      y: item
    };
  });
  var maxX = processed.length - 1;
  var minY = processed.reduce(function (min, point) {
    return point.y < min ? point.y : min;
  }, processed[0].y);
  var maxY = processed.reduce(function (max, point) {
    return point.y > max ? point.y : max;
  }, processed[0].y);
  var diffY = (height - safe * 2) / (maxY - minY);
  var getSvgX = function getSvgX(x) {
    return x / maxX * width;
  };
  var getSvgY = function getSvgY(y) {
    return height - safe - (y - minY) * diffY;
  };
  var makePolyline = function makePolyline() {
    var points = '';
    processed.forEach(function (point) {
      points += "".concat(getSvgX(point.x), ",").concat(getSvgY(point.y), "\n");
    });
    return React.createElement("polyline", {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: strokeWidth,
      points: points,
      vectorEffect: "non-scaling-stroke"
    });
  };
  return React.createElement("svg", {
    viewBox: "0 0 ".concat(width, " ").concat(height)
  }, makePolyline());
};